import React from "react";
import styles from "./TableMovements.module.css";
import "./TableMovements.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { MOVIMIENTOS, getMovimientosByFund } from "../../constants/mockData";


const TableMovements = ({ tipo = "general", customData }) => {
  const capitalizeWords = (str) => {
    let texto = str.replaceAll("-", " ");
    let exceptions = ["y", "de"];
    return texto
      .toLowerCase()
      .split(" ")
      .map((word) => {
        if (exceptions.includes(word)) {
          return word;
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      })
      .join(" ");
  };

  // Si customData está presente, usarlo directamente
  const data = (customData ? customData : (() => {
    if (tipo === "amarillo") {
      return getMovimientosByFund(101);
    } else if (tipo === "verde") {
      return getMovimientosByFund(102);
    } else if (tipo === "azul") {
      return getMovimientosByFund(103);
    } else {
      return MOVIMIENTOS;
    }
  })()).map(mov => {
    let statusRaw = mov.estado || mov.status;
    let status = statusRaw ? statusRaw.toLowerCase() : "";
    return {
      movimiento: mov.movimiento,
      proyecto_c: mov.proyecto_c || mov.fondoInfo?.name || mov.fideicomiso || "",
      fecha: mov.fecha,
      saldo: `$${mov.saldo ? mov.saldo.toLocaleString('es-CO') : mov.saldo}`,
      status
    };
  });

  return (
    <div className="table-investments">
      <div className={styles.tableViewNewInvoice}>
        <div className="table-responsive">
          <table className="table table-borderless">
            <thead>
              <tr className="head border-top-0">
                <th scope="col" className="first-col">Tipo de movimiento</th>
                <th scope="col" className="middle-col">Vehículo de inversión</th>
                <th scope="col" className="middle-col">Fecha</th>
                <th scope="col" className="middle-col">Saldo</th>
                <th scope="col" className="middle-col">Estado</th>
                {/* <th scope="col" className="middle-col">Acciones</th> */}
              </tr>
            </thead>
            <tbody>
              {data.map((data, i) => (
                <tr key={"row-" + tipo + "-" + i} className="row-component-investments">
                  <td className="col-component-investments">
                    <div className="td-txt">{data.movimiento}</div>
                  </td>
                  <td className="col-component-investments">
                    <div className="center col-fecha-inversion">{data.proyecto_c}</div>
                  </td>
                  <td className="col-component-investments">
                    <div className="center col-fecha-inversion">{data.fecha}</div>
                  </td>
                  <td className="col-component-investments">
                    <div className="col-rendimientos">{data.saldo}</div>
                  </td>
                  <td className="col-component-investments">
                    <div className={"center col-" + data.status}>
                      {capitalizeWords(data.status)}
                    </div>
                  </td>
                  {/* <td className="col-component-investments">
                    <div className="center col-propiedad">
                      <FontAwesomeIcon
                        style={{ width: "25px", height: "25px", color: "#787878", cursor: "pointer" }}
                        icon={faEllipsisV}
                      />
                    </div>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
          {/* <div className="col-md-12">
            <div className="_card-footer">
              <div className="_card-footer-right">
                Ver todo <li className="arrow-right"></li>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TableMovements;